"use client";

// Components
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/toaster";
import { PasswordInput } from "@/components/common/forms/PasswordInput";

// Controllers
import useCreateAccountController from "../controllers/createAccount.controller";
import Captcha from "@/components/accounts/Captcha";

const CreateAccountForm = () => {
  const { isPending, form, handleSubmit, handleCaptcha, captchaResolved } =
    useCreateAccountController();

  return (
    <>
      <Toaster />

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          className="w-full mb-4"
        >
          <FormField
            control={form.control}
            name="nombre"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nombre</FormLabel>
                <FormControl>
                  <Input placeholder="Nombre" {...field} />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="apellido"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Apellido</FormLabel>
                <FormControl>
                  <Input placeholder="Apellido" {...field} />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="correo"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Correo electronico</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Ingresa tu correo electronico"
                    {...field}
                  />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Ingresa una contraseña segura</FormLabel>
                <FormControl>
                  <PasswordInput placeholder="Contraseña" {...field} />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="passwordConfirmation"
            render={({ field }) => (
              <FormItem className="mb-5">
                <FormLabel>Confirma tu contraseña</FormLabel>
                <FormControl>
                  <PasswordInput
                    placeholder="Repite tu contraseña"
                    {...field}
                  />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="w-full flex justify-center mb-6">
            <Captcha
              onChange={(token) => handleCaptcha(!!token)}
              expireCallback={() => handleCaptcha(false)}
            />
          </div>

          <FormControl>
            <Button
              type="submit"
              className="w-full"
              disabled={isPending || !captchaResolved}
            >
              Continuar
            </Button>
          </FormControl>
        </form>
      </Form>
    </>
  );
};

export default CreateAccountForm;
